import { ChevronDown, Sprout, X } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface BannerHeaderProps {
  title: string;
  icon?: ReactNode;
  expanded: boolean;
  onToggle: () => void;
  onDismiss?: () => void;
}

export function BannerHeader({
  title,
  icon,
  expanded,
  onToggle,
  onDismiss,
}: BannerHeaderProps) {
  return (
    <div className="flex w-full items-center gap-2">
      <button
        type="button"
        onClick={onToggle}
        className="flex flex-1 items-center justify-between"
      >
        <div className="flex items-center gap-1">
          {icon ?? <Sprout className="h-6 w-6 text-text-primary" />}
          <span className="text-base font-bold leading-5 tracking-[-0.32px] text-text-primary">
            {title}
          </span>
        </div>
        <ChevronDown
          className={cn(
            "h-6 w-6 text-text-secondary transition-transform duration-200",
            !expanded && "rotate-180",
          )}
        />
      </button>
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 rounded-md p-1 text-text-secondary hover:bg-surfaces-z4"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      ) : null}
    </div>
  );
}
